import {
  Building2Icon,
  CalendarDaysIcon,
  CreditCardIcon,
  HomeIcon,
  MapIcon,
  ReceiptTextIcon,
  SettingsIcon,
  type LucideIcon,
} from "lucide-react";
import type { AppSession } from "@/app/session";

export type NavLink = { kind: "link"; label: string; href: string; icon: LucideIcon };
export type NavGroup = {
  kind: "group";
  label: string;
  icon: LucideIcon;
  children: { label: string; href: string }[];
};
export type NavEntry = NavLink | NavGroup;

type ActiveSession = Extract<AppSession, { status: "admin" | "company" | "driver" }>;

/**
 * Role-specific nav sets, matching the Flutter app's sidebar/drawer exactly
 * (`web_sidebar.dart`), except admin also gets Cards: subcontractors + cards
 * + an expandable reports group + money codes; company gets map + reports/cards + money codes only when
 * `isMoneyCodeEnabled`; driver gets home + cards only.
 */
export function navItemsFor(session: ActiveSession): NavEntry[] {
  if (session.status === "admin") {
    return [
      { kind: "link", label: "Home", href: "/home", icon: HomeIcon },
      { kind: "link", label: "Subcontractors", href: "/companies", icon: Building2Icon },
      { kind: "link", label: "Cards", href: "/cards", icon: CreditCardIcon },
      {
        kind: "group",
        label: "Reports",
        icon: CalendarDaysIcon,
        children: [
          { label: "Weekly Fuel", href: "/weeks" },
          { label: "Monthly Card Use", href: "/monthly-reports" },
        ],
      },
      { kind: "link", label: "Money Codes", href: "/money-codes", icon: ReceiptTextIcon },
      { kind: "link", label: "Settings", href: "/settings", icon: SettingsIcon },
    ];
  }

  if (session.status === "company") {
    const items: NavEntry[] = [
      { kind: "link", label: "Home", href: "/home", icon: HomeIcon },
      { kind: "link", label: "Map", href: "/map", icon: MapIcon },
      { kind: "link", label: "Reports", href: "/weeks", icon: CalendarDaysIcon },
      { kind: "link", label: "Cards", href: "/cards", icon: CreditCardIcon },
    ];
    if (session.company.isMoneyCodeEnabled) {
      items.push({ kind: "link", label: "Money Codes", href: "/money-codes", icon: ReceiptTextIcon });
    }
    return items;
  }

  // driver
  return [
    { kind: "link", label: "Home", href: "/home", icon: HomeIcon },
    { kind: "link", label: "Card", href: "/cards", icon: CreditCardIcon },
  ];
}
